<template>
  <article v-if="loaded" class="choose-doctor">
    <router-link
      class="choose-doctor__logout"
      to="/logout"
    >
      <dr-icon
        class="clickable logout-icon"
        color="white"
        name="logout"
      />
    </router-link>

    <section class="choose-doctor__wrapper">
      <figure class="choose-doctor__logo">
        <dr-vector :src="logo" color="white" />
      </figure>

      <div class="choose-doctor__text">
        <p>
          <strong>Boa tarde, {{name}}</strong>
        </p>

        <p>
          Por favor, selecione o(a) médico(a) que você irá administrar agora:
        </p>
      </div>

      <ul class="choose-doctor__doctor-list">
        <li
          v-for="doctor of doctors"
          :key="`dr-${doctor.id}`"
          class="choose-doctor__doctor-item"
        >
          <router-link
            :to="`/secretary/doctor/${doctor.id}`"
            class="choose-doctor__doctor-details"
          >
            <figure class="choose-doctor__doctor-details">
              <img
                :src="fn_GET_AVATAR(doctor.user)"
                class="choose-doctor__doctor-img"
              />

              <figcaption class="choose-doctor__doctor-name">
                {{ doctor.gender === 'F' ? 'Dra.' : 'Dr.' }} {{ doctor.name }}
              </figcaption>
            </figure>
          </router-link>
        </li>
      </ul>
    </section>
  </article>
</template>

<script>
import logo from '@/assets/img/Logo.svg'

export default {
  data () {
    return {
      logo,
      name: null,
      loaded: false,
      doctors: []
    }
  },
  mounted () {
    this.$http.get(`/user`, this.$store.getters.getAuthHeader).then(
      (res) => {
        let user = res.data
        this.name = user.name
        this.$http.get('secretary/doctor', this.$store.getters.getAuthHeader).then(
          (res) => {
            let doctors = []
            for (let doctor of res.data) {
              const avatar = doctor.profile_picture
                ? `${process.env.ROOT_API}/s3/file/doctor/${this.doctor.id}/profile_picture`
                : doctor.user.gender === 'F'
                  ? require('@/assets/img/f_default.png')
                  : require('@/assets/img/m_default.png')

              doctors.push(
                {
                  id: doctor.id,
                  name: doctor.user.name,
                  profile_picture: avatar,
                  gender: doctor.user.gender,
                  roles: doctor.user.roles
                }
              )
            }
            this.doctors = doctors
            let profile = {
              id: user.id,
              name: user.name,
              picture: `${process.env.ROOT_API}/s3/file/doctor/${this.doctor.id}/profile_picture`,
              doctorList: doctors
            }
            this.$store.dispatch('setUserProfile', profile)
          }
        ).catch(
          (err) => {
            console.log(err)
          }
        ).finally(
          () => {
            this.fn_HIDE_PROGRESS()
            this.loaded = true
          }
        )
      }
    ).catch(
      (err) => {
        console.log(err)
      }
    )
  }
}
</script>
